import React from "react";
import style from "./review.module.scss";
import { NavLink } from "react-router-dom";

interface IReviewSummary {
  status: string;
  statusCounter: {
    pending: number;
    rejected: number;
    approved: number;
  };
}

enum ReviewStatus {
  PENDING = "PENDING",
  ACCEPTED = "APPROVED",
  REJECTED = "REJECTED",
}

const ReviewSummaryCard = ({ status, statusCounter }: IReviewSummary) => {
  return (
    <>
      <section className={style.reviewMainPageStyle}>
        {status === ReviewStatus.PENDING && (
          <>
            <div className={style.reviewSumationCard}>
              <NavLink to={`/review?status=${ReviewStatus.ACCEPTED}`}>
                <h5 className={style.approved}>Approved Reviews</h5>
              </NavLink>
              <p>{statusCounter.approved}</p>
            </div>

            <div className={style.reviewSumationCard}>
              <NavLink to={`/review?status=${ReviewStatus.REJECTED}`}>
                <h5 className={style.rejected}>Rejected Reviews</h5>
              </NavLink>
              <p>{statusCounter.rejected}</p>
            </div>
          </>
        )}

        {status === ReviewStatus.REJECTED && (
          <>
            <div className={style.reviewSumationCard}>
              <NavLink to={`/review?status=${ReviewStatus.ACCEPTED}`}>
                <h5 className={style.approved}>Approve Reviews</h5>
              </NavLink>
              <p>{statusCounter.approved}</p>
            </div>

            <div className={style.reviewSumationCard}>
              <NavLink to={`/review?status=${ReviewStatus.PENDING}`}>
                <h5 className={style.pending}>Pending Reviews</h5>
              </NavLink>
              <p>{statusCounter.pending}</p>
            </div>
          </>
        )}

        {status === ReviewStatus.ACCEPTED && (
          <>
            <div className={style.reviewSumationCard}>
              <NavLink to={`/review?status=${ReviewStatus.PENDING}`}>
                <h5 className={style.pending}>Pending Reviews</h5>
              </NavLink>
              <p>{statusCounter.pending}</p>
            </div>

            <div className={style.reviewSumationCard}>
              <NavLink to={`/review?status=${ReviewStatus.REJECTED}`}>
                <h5 className={style.rejected}>Rejected Reviews</h5>
              </NavLink>
              <p>{statusCounter.rejected}</p>
            </div>
          </>
        )}
      </section>
    </>
  );
};

export default ReviewSummaryCard;
